<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.displayName">

<!--    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">-->

      <router-link tag="div" to="/personal"
        class="text-right float-right leading-tight w-full sm:w-128 md:w-128 xl:w-128 lg:w-128 cursor-pointer h-16 table">
        <div class="inline-block mr-1 h-16 align-middle table-cell w-5/6">
          <p class="font-semibold">
            {{ activeUserInfo.name }} <br />
            <small>{{ activeUserInfo.org }}</small>
          </p>
        </div>
        <div class="table-cell h-6 m-0 ml-1 p-0 align-middle w-1/6 sm:w-2 md:w-2 xl::w-2 lg::w-2">
          <p class="font-semibold bg-primary text-white p-2 round text-center mx-2 w-10 h-10">
            {{ activeUserInfo.displayName }}
          </p>
        </div>
      </router-link>


<!--      <vs-dropdown-menu class="vx-navbar-dropdown">-->
<!--        <ul style="min-width: 9rem">-->

<!--          <router-link to="/personal" href="/personal"-->
<!--            tag="li" class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">-->
<!--            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />-->
<!--            <span class="ml-2">{{ $t('message.profile.personalButton') }}</span>-->
<!--          </router-link>-->

<!--          <vs-divider class="m-1" style="display: none" />-->
<!--        </ul>-->
<!--      </vs-dropdown-menu>-->
<!--    </vs-dropdown>-->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters('user', {activeUserInfo: 'activeUserInfo'})
  },
  methods: {
    ...mapActions('user', { logout: 'logout' })
  }
}
</script>
